import React from 'react';
import { useHistory } from 'react-router-dom';
import { TextInput, Address, SelectBox, TextArea, Button, MoreFile } from '../../components';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Handler from '../../Handler';

const renderTerms = (item) => {
  const { title, file } = item;

  return (
    <li>
      <Accordion>
        <AccordionSummary expandIcon={<div className='ico arrow-down'></div>}>
          <div className='title__box'>
            <span>{title}</span>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className='content__box'></div>
        </AccordionDetails>
      </Accordion>
    </li>
  );
};

export const ContentCredit = (props) => {
  const history = useHistory();
  const {
    mode,
    formData,
    formMeta,
    formChange,
    setFromData,
    setFormMeta,
    contentMeta,
    contentMetaChange,
    readOnly,
    type,
    callback,
  } = props;

  const buildMeta = (meta) => {
    let meta_value = { ...meta };

    if (readOnly) {
      meta_value.readOnly = true;
    }
    return meta_value;
  };

  switch (mode) {
    case 'issue': {
      return (
        <article className='content-project'>
          <section className='section__container'>
            <header>
              <h2>신청자 정보</h2>
            </header>
            <ul className='form-list'>
              <TextInput
                value={contentMeta.companyName}
                meta={buildMeta({
                  key: 'companyName',
                  label: '기업명',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.businessNumber}
                meta={buildMeta({
                  key: 'businessNumber',
                  label: '사업자등록번호',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.ceoName}
                meta={buildMeta({
                  key: 'ceoName',
                  label: '대표자명',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.phone}
                meta={buildMeta({
                  key: 'phone',
                  label: '연락처(휴대폰)',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>

              {contentMeta.address && (
                <Address
                  value={contentMeta.address}
                  onChange={formChange}
                  meta={buildMeta({
                    required: true,
                    disabled: true,
                    key: 'address',
                    label: '본사 주소',
                    type: 'content',
                    style: {
                      gridColumn: '1/3',
                    },
                  })}
                ></Address>
              )}
            </ul>
            <div style={{ width: 944, marginTop: 40, marginBottom: 40 }} className='border-grey-200'></div>
            <ul className='form-list'>
              <TextInput value={formData.name} meta={buildMeta(formMeta.name)} onChange={formChange}></TextInput>
              <TextInput value={formData.phone} meta={buildMeta(formMeta.phone)} onChange={formChange}></TextInput>
              <TextInput value={formData.team} meta={buildMeta(formMeta.team)} onChange={formChange}></TextInput>
              <TextInput value={formData.email} meta={buildMeta(formMeta.email)} onChange={formChange}></TextInput>
            </ul>
          </section>
          <section className='section__container'>
            <header>
              <h2>크레딧 발행 정보</h2>
            </header>
            <ul className='form-list'>
              {readOnly ? (
                <>
                  <TextInput
                    value={contentMeta.projectTitle}
                    meta={buildMeta({
                      key: 'projectTitle',
                      label: '사업명',
                      disabled: true,
                      required: true,
                      style: {
                        gridColumn: '1/3',
                      },
                    })}
                    onChange={formChange}
                  ></TextInput>
                  <TextInput
                    value={contentMeta.monitorDegree + '차'}
                    meta={buildMeta({
                      key: 'monitorDegree',
                      label: '모니터링 차수',
                      disabled: true,
                      required: true,
                      style: {
                        gridColumn: '1/3',
                        maxWidth: '420px',
                      },
                    })}
                    onChange={formChange}
                  ></TextInput>
                  <TextInput
                    value={contentMeta.requestCredit ? Handler.numberWithCommas(contentMeta.requestCredit) : ''}
                    meta={buildMeta({
                      key: 'requestCredit',
                      label: '크레딧 발행 수량',
                      className: 'unit',
                      unitLabel: 'ZC 크레딧',
                      disabled: true,
                      required: true,
                      style: {
                        maxWidth: '420px',
                      },
                    })}
                    onChange={formChange}
                  ></TextInput>
                </>
              ) : (
                <>
                  <SelectBox
                    value={formData.issueProjectSeq}
                    onChange={formChange}
                    meta={buildMeta(formMeta.issueProjectSeq)}
                  ></SelectBox>
                  <SelectBox
                    value={formData.reductionCertSeq}
                    onChange={formChange}
                    meta={buildMeta(formMeta.reductionCertSeq)}
                  ></SelectBox>
                  <TextInput
                    value={contentMeta.requestCredit ? Handler.numberWithCommas(contentMeta.requestCredit) : ''}
                    meta={buildMeta({
                      key: 'requestCredit',
                      label: '크레딧 발행 수량',
                      className: 'unit',
                      unitLabel: 'ZC 크레딧',
                      disabled: true,
                      required: true,
                      style: {
                        maxWidth: '420px',
                      },
                    })}
                    onChange={formChange}
                  ></TextInput>
                </>
              )}
            </ul>
          </section>
        </article>
      );
    }
    case 'move': {
      return (
        <article className='content-project'>
          <section className='section__container'>
            <header>
              <h2>양도인 정보</h2>
            </header>
            <ul className='form-list'>
              <TextInput
                value={contentMeta.companyName}
                meta={buildMeta({
                  key: 'companyName',
                  label: '기업명',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.businessNumber}
                meta={buildMeta({
                  key: 'businessNumber',
                  label: '사업자등록번호',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.ceoName}
                meta={buildMeta({
                  key: 'ceoName',
                  label: '대표자명',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.phone}
                meta={buildMeta({
                  key: 'phone',
                  label: '연락처(휴대폰)',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>

              {contentMeta.address && (
                <Address
                  value={contentMeta.address}
                  onChange={formChange}
                  meta={buildMeta({
                    required: true,
                    disabled: true,
                    key: 'address',
                    label: '본사 주소',
                    type: 'content',
                    style: {
                      gridColumn: '1/3',
                    },
                  })}
                ></Address>
              )}
            </ul>
            <div style={{ width: 944, marginTop: 40, marginBottom: 40 }} className='border-grey-200'></div>
            <ul className='form-list'>
              <TextInput
                value={formData.assignorName}
                meta={buildMeta(formMeta.assignorName)}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={formData.assignorPhone}
                meta={buildMeta(formMeta.assignorPhone)}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={formData.assignorTeam}
                meta={buildMeta(formMeta.assignorTeam)}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={formData.assignorEmail}
                meta={buildMeta(formMeta.assignorEmail)}
                onChange={formChange}
              ></TextInput>
            </ul>
          </section>
          <section className='section__container'>
            <header>
              <h2>양수인 정보</h2>
            </header>
            <ul className='form-list'>
              <div style={{ display: 'flex', width: '100%', alignItems: 'flex-end' }}>
                <TextInput
                  value={contentMeta.companyNameAssignee}
                  meta={buildMeta({
                    key: 'companyName',
                    label: '기업명',
                    disabled: true,
                    required: true,
                    style: {
                      width: '100%',
                    },
                  })}
                  onChange={formChange}
                ></TextInput>
                <Button
                  disabled={readOnly}
                  onClick={() => {
                    callback('search');
                  }}
                  type='secondary-square'
                  style={{ width: '120px', marginLeft: 16 }}
                  label={'검색'}
                ></Button>
              </div>

              <TextInput
                value={contentMeta.businessNumberAssignee}
                meta={buildMeta({
                  key: 'businessNumber',
                  label: '사업자등록번호',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.ceoNameAssignee}
                meta={buildMeta({
                  key: 'ceoName',
                  label: '대표자명',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.phoneAssignee}
                meta={buildMeta({
                  key: 'phone',
                  label: '연락처(휴대폰)',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>

              <Address
                value={contentMeta.addressAssignee || { daum: null, detail: '' }}
                onChange={formChange}
                meta={buildMeta({
                  required: true,
                  disabled: true,
                  key: 'address',
                  label: '본사 주소',
                  type: 'content',
                  style: {
                    gridColumn: '1/3',
                  },
                })}
              ></Address>
            </ul>
            <div style={{ width: 944, marginTop: 40, marginBottom: 40 }} className='border-grey-200'></div>
            <ul className='form-list'>
              <TextInput
                value={formData.assigneeName}
                meta={buildMeta(formMeta.assigneeName)}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={formData.assigneePhone}
                meta={buildMeta(formMeta.assigneePhone)}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={formData.assigneeTeam}
                meta={buildMeta(formMeta.assigneeTeam)}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={formData.assigneeEmail}
                meta={buildMeta(formMeta.assigneeEmail)}
                onChange={formChange}
              ></TextInput>
            </ul>
          </section>
          <section className='section__container'>
            <header>
              <h2>크레딧 이전 정보</h2>
            </header>
            <ul className='form-list'>
              {readOnly ? (
                <>
                  <TextInput
                    value={contentMeta.projectTitle}
                    meta={buildMeta({
                      key: 'projectTitle',
                      label: '사업명',
                      disabled: true,
                      required: true,
                      style: {
                        gridColumn: '1/3',
                      },
                    })}
                    onChange={formChange}
                  ></TextInput>
                  <div style={{ display: 'flex', alignItems: 'flex-end', gridColumn: '1/3' }}>
                    <TextInput
                      value={Handler.numberWithCommas(formData.amount)}
                      meta={buildMeta(formMeta.amount)}
                      onChange={formChange}
                    ></TextInput>
                  </div>

                  <TextInput
                    value={formData.reason}
                    meta={buildMeta(formMeta.reason)}
                    onChange={formChange}
                  ></TextInput>
                  <TextArea
                    value={formData.reasonDetail}
                    onChange={formChange}
                    meta={buildMeta(formMeta.reasonDetail)}
                  ></TextArea>
                  <MoreFile value={formData.files} onChange={formChange} meta={buildMeta(formMeta.files)}></MoreFile>
                </>
              ) : (
                <>
                  <SelectBox
                    value={formData.projectSeq}
                    onChange={formChange}
                    meta={buildMeta(formMeta.projectSeq)}
                  ></SelectBox>
                  <div style={{ display: 'flex', alignItems: 'flex-end', gridColumn: '1/3' }}>
                    <TextInput
                      value={formData.amount}
                      meta={buildMeta(formMeta.amount)}
                      onChange={formChange}
                    ></TextInput>
                    <span style={{ marginBottom: 14, marginLeft: 12, fontSize: 14 }}>
                      이전 가능한 크레딧 수량 :{' '}
                      <em style={{ color: '#5d3be5' }}>{Handler.numberWithCommas(contentMeta.reductionNow)}</em> ZC
                      크레딧
                    </span>
                  </div>
                  <SelectBox
                    value={formData.reason}
                    onChange={formChange}
                    meta={buildMeta(formMeta.reason)}
                  ></SelectBox>
                  <TextArea
                    value={formData.reasonDetail}
                    onChange={formChange}
                    meta={buildMeta(formMeta.reasonDetail)}
                  ></TextArea>
                  <MoreFile value={formData.files} onChange={formChange} meta={buildMeta(formMeta.files)}></MoreFile>
                </>
              )}
            </ul>
          </section>
        </article>
      );
    }
    case 'offset': {
      return (
        <article className='content-project'>
          <section className='section__container'>
            <header>
              <h2>신청자 정보</h2>
            </header>
            <ul className='form-list'>
              <TextInput
                value={contentMeta.companyName}
                meta={buildMeta({
                  key: 'companyName',
                  label: '기업명',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.businessNumber}
                meta={buildMeta({
                  key: 'businessNumber',
                  label: '사업자등록번호',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.ceoName}
                meta={buildMeta({
                  key: 'ceoName',
                  label: '대표자명',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>
              <TextInput
                value={contentMeta.phone}
                meta={buildMeta({
                  key: 'phone',
                  label: '연락처(휴대폰)',
                  disabled: true,
                  required: true,
                  style: {
                    maxWidth: '420px',
                  },
                })}
                onChange={formChange}
              ></TextInput>

              {contentMeta.address && (
                <Address
                  value={contentMeta.address}
                  onChange={formChange}
                  meta={buildMeta({
                    required: true,
                    disabled: true,
                    key: 'address',
                    label: '본사 주소',
                    type: 'content',
                    style: {
                      gridColumn: '1/3',
                    },
                  })}
                ></Address>
              )}
            </ul>
            <div style={{ width: 944, marginTop: 40, marginBottom: 40 }} className='border-grey-200'></div>
            <ul className='form-list'>
              <TextInput value={formData.name} meta={buildMeta(formMeta.name)} onChange={formChange}></TextInput>
              <TextInput value={formData.phone} meta={buildMeta(formMeta.phone)} onChange={formChange}></TextInput>
              <TextInput value={formData.team} meta={buildMeta(formMeta.team)} onChange={formChange}></TextInput>
              <TextInput value={formData.email} meta={buildMeta(formMeta.email)} onChange={formChange}></TextInput>
            </ul>
          </section>
          <section className='section__container'>
            <header>
              <h2>크레딧 상쇄 정보</h2>
            </header>
            <ul className='form-list'>
              {readOnly ? (
                <>
                  <TextInput
                    value={contentMeta.projectTitle}
                    meta={buildMeta({
                      key: 'projectTitle',
                      label: '사업명',
                      disabled: true,
                      required: true,
                      style: {
                        gridColumn: '1/3',
                      },
                    })}
                    onChange={formChange}
                  ></TextInput>
                  <TextInput
                    value={Handler.numberWithCommas(contentMeta.amount)}
                    meta={buildMeta({
                      key: 'requestCredit',
                      label: '크레딧 상쇄 수량',
                      className: 'unit',
                      unitLabel: 'ZC 크레딧',
                      disabled: true,
                      required: true,
                      style: {
                        maxWidth: '420px',
                      },
                    })}
                    onChange={formChange}
                  ></TextInput>
                  <TextInput
                    value={formData.reason}
                    meta={buildMeta(formMeta.offsetReason)}
                    onChange={formChange}
                  ></TextInput>
                  {formData.reason === '직접 입력' && (
                    <TextInput
                      value={formData.reasonDetail}
                      meta={buildMeta(formMeta.reasonCustom)}
                      onChange={formChange}
                    ></TextInput>
                  )}
                </>
              ) : (
                <>
                  <SelectBox
                    value={formData.projectSeq}
                    onChange={formChange}
                    meta={buildMeta(formMeta.projectSeq)}
                  ></SelectBox>
                  <TextInput
                    value={contentMeta.reductionNow ? Handler.numberWithCommas(contentMeta.reductionNow) : ''}
                    meta={buildMeta({
                      key: 'requestCredit',
                      label: '크레딧 상쇄 수량',
                      className: 'unit',
                      unitLabel: 'ZC 크레딧',
                      disabled: true,
                      required: true,
                      style: {
                        maxWidth: '420px',
                      },
                    })}
                    onChange={formChange}
                  ></TextInput>
                  <SelectBox
                    value={formData.reason}
                    onChange={formChange}
                    meta={buildMeta(formMeta.offsetReason)}
                  ></SelectBox>
                  {formData.reason === '직접 입력' && (
                    <TextInput
                      value={formData.reasonCustom}
                      meta={buildMeta(formMeta.reasonCustom)}
                      onChange={formChange}
                    ></TextInput>
                  )}
                </>
              )}
            </ul>
          </section>
        </article>
      );
    }
    default: {
      return null;
    }
  }
};
